import * as React from "react"
import Grid from "@mui/material/Grid"
import Link from "@mui/material/Link"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

const Social = ({ label, data }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      <Typography mb={1} sx={{ fontSize: "10px", color: "#fff" }}>
        {label}
      </Typography>
      <Grid
        container
        spacing={0}
        justifyContent="flex-start"
        sx={{
          color: "#fff",
        }}
      >
        {data?.map((item, key) => {
          const Icon = item?.icon;
          const handleClick = item?.onClick;

          return (
            <Link onClick={handleClick} rel="noopener" target="_blank" key={key}>
              <Grid item>
                <Icon
                  fontSize="medium"
                  sx={{
                    color: "#fff", 
                    margin: "0 18px",
                    marginLeft: 0,
                    cursor: 'pointer'
                  }}
                />
              </Grid>
            </Link>
          )
        })}
      </Grid>
    </Box>
  )
}

export default Social
